import { render, staticRenderFns } from "./CustomerGroups.vue?vue&type=template&id=56e876a7&scoped=true"
import script from "./CustomerGroups.vue?vue&type=script&lang=js"
export * from "./CustomerGroups.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroups.vue?vue&type=style&index=0&id=56e876a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e876a7",
  null
  
)

export default component.exports